<template>
  <div id="activities" class="video-swiper-item">
    <p class="header" :class="{showAdcss: showAd == k}" v-for="(v, k) in adList" :key="k">
      <img
        :src="v.image"
        class="avatur"
        @click="goAdDetail(v)"
        :style="styleObject"
      >
    </p>
    <p class="header showAdcss" v-if="adList.length == 0">
      <img
        src="../../assets/img/videoDetail/newbanner.png"
        class="avatur"
        @click="goRouter('/SdInquiry')"
        :style="styleObject"
      >
    </p>
  </div>
</template>
<script>
import {adH5} from '@/api/index';
  export default {
    name: "ledAd",
    data() {
      return {
        showAd: 0,
        adList: [],
        currentwidth: "",
        currentheight: "",
        styleObject: {}
      };
    },
    props: {
      adWidth: [Number, String],
      adHeight: [Number, String]
    },
    created() {
      this.styleObject.width = this.adWidth / 37.5 + "rem";
      this.styleObject.height = this.adHeight / 37.5 + "rem";
      this.ledAd();
    },
    methods: {
      // 广告跳转
      ledAd() {
        this.$http.get(adH5).then(res => {
          if (res.data.code == 0) {
            this.adList = res.data.data;
            // 子传父
            this.$emit('getChildData', res.data.data)
            if (this.adList.length > 1) {
              let adSwiper = setInterval(() => {
                this.showAd += 1;
                if (this.showAd > this.adList.length - 1) {
                  this.showAd = 0;
                }
              }, 6000);
            } else {
              this.showAd = 0;
            }
          }
        });
      },
      goAdDetail(v) {
        // console.log(v.link)
        window.location.href = v.link;
      },
      goRouter(val) {
        this.$router.push(val);
      }
    }
  };
</script>
<style lang="postcss" scoped>
  #activities.video-swiper-item {
    position: relative;
    vertical-align: top;
    width: 644px;
    height: 114px;
    display: inline-block;
    & .header {
      position: absolute;
      opacity: 0;
      display: flex;
      align-content: center;
      align-items: center;
      width: 100%;
      border-radius: 10px;
      transition: all 1s;
      & .avatur {
        width: 643px;
        height: 114px;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 14px 20px -10px rgba(80, 82, 88, 0.6);
      }
      & .name {
        font-size: 36px;
        font-family: SourceHanSansCN-Medium;
        color: #333;
      }
    }
    & .showAdcss {
      opacity: 1;
      z-index: 1;
    }
    & ul {
      margin-top: 40px;
      & li:last-child {
        margin-bottom: 0;
      }
    }
    & .relative-video-item {
      display: flex;
      align-content: center;
      align-items: center;
      margin-bottom: 20px;
      & img {
        width: 234px;
        height: 123px;
        margin-right: 20px;
        object-fit: cover;
      }
      & > div {
        & .title {
          font-size: 28px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: #333;
        }
        & .content {
          margin-top: 16px;
          font-size: 24px;
          font-family: SourceHanSansCN-Regular;
          color: #999;
          width: 357px;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 1;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/public/Activities.vue